class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    
    if (document.querySelector('.cart-shipping')) {
      this.minSpend = document.querySelector('.cart-shipping').dataset.minSpend;
      this.minTotal = Math.round(this.minSpend * (Shopify.currency.rate || 1));
      this.cartShipping();
    }

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.total = document.querySelector('.cart-shipping').dataset.total;
    setTimeout(()=>{
      this.updateCartBar(this.total);
      this.removeGiftProduct();
    }, 1000);
  }

  cartUpdateUnsubscriber = undefined;
  btnAddProductHandler = null;
  btnAddProductListenerAttached = false;
  btnAddProductProcessing = false;

  cartShipping() {
    let progressPrev = getComputedStyle(document.querySelector('.cart-shipping__progress-current')).getPropertyValue('width');    
    document.documentElement.style.setProperty('--progress-prev', progressPrev);

    this.total = document.querySelector('.cart-shipping').dataset.total;
    this.progress = this.total / this.minTotal * 100;
    if (this.progress > 100)
      this.progress = 100;

    if (this.minTotal > this.total) {
      let amount = this.minTotal - this.total;
      let message = document.querySelector('.cart-shipping').dataset.message.replace('||amount||', formatMoney(amount));
      document.querySelector('.cart-shipping__message_default').innerText = message;
      document.querySelector('.cart-shipping__message_success').classList.remove('active');
      document.querySelector('.cart-shipping__message_default').classList.add('active');
    }
    else {
      document.querySelector('.cart-shipping__message_default').classList.remove('active');
      document.querySelector('.cart-shipping__message_success').classList.add('active');
    }
    document.querySelector('.cart-shipping__progress-current').style.width = this.progress+'%';
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        // Reset flags when DOM is replaced since button will be recreated
        this.btnAddProductListenerAttached = false;
        this.btnAddProductProcessing = false;
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-totals'
      },
      {
        id: 'main-cart-shipping',
        section: document.getElementById('main-cart-shipping').dataset.id || null,
        selector: '.js-contents-shipping'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll('.quantity__button').forEach((button) => button.classList.add('disabled'));
    
    if (document.querySelectorAll('#main-cart-items .card--product card__add-to-cart button[name="add"]')) {
      document.querySelectorAll('#main-cart-items .card--product .card__add-to-cart button[name="add"]').forEach(button => {
        button.setAttribute('aria-disabled', false);
        if (button.querySelector('span')) {
          button.querySelector('span').classList.remove('hidden');
          button.querySelector('.sold-out-message').classList.add('hidden');
        }
      });
    }

    if (document.querySelector('.cart-shipping')) {
      let progressPrev = getComputedStyle(document.querySelector('.cart-shipping__progress-current')).getPropertyValue('width');    
      document.documentElement.style.setProperty('--progress-prev', progressPrev);
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

         console.log('Parsed State:', parsedState);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.querySelectorAll('.quantity__button').forEach((button) => button.classList.remove('disabled'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.querySelectorAll('.quantity__button').forEach((button) => button.classList.remove('disabled'));
        if (document.querySelector('.cart-shipping')) {
          this.cartShipping();
        }
        this.disableLoading(line);

        this.total = document.querySelector('.cart-shipping').dataset.total;
        // console.log('total', this.total);
        this.updateCartBar(this.total);
        this.removeGiftProduct();
        console.log("UDPATE QUANTITY");
      });
  }

  removeGiftProduct(id = 9217987936582) {
    const limit = 449.00; 
    const total = this.total / 100; // Assuming total is in cents, convert it to dollars
    // If the total is less than the limit, remove the product with the given id
    if (total < limit) { 
      const giftProduct = this.querySelector(`[data-product-id="${id}"]`);
      if (giftProduct != null) {
        if (!window.location.href.includes('/cart')) {
        //Drawer 
          fetch(giftProduct.getAttribute('data-product-remove-url'), {
            method: 'GET',  
          })
            .then((response) => {
              console.log(response);
              window.location.href = window.location.href + '?cart_drawer=1';
            })
            .catch((error) => {
              console.error('Error:', error);
            })
          
        }
        else {
          this.updateQuantity(giftProduct.dataset.index, 0); // Set quantity to 0 to remove the product
        }
      }
    }
  }


  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  updateCartBar(total) {
    if (!document.querySelector('.template-cart')) return;
    
    const limit = 449.00;
    total = total/100;
    let diff = limit - total;

      // Handle when the limit is reached or exceeded
      if (diff <= 0) {
          document.querySelector('.template-cart .product-recommendations .section-header').style.display = 'none';
          document.querySelector('.template-cart .product-recommendations .swiper-wrapper').style.display = 'none';
          document.querySelector('.template-cart .cart-recommendations__bar .bar').style.display = 'none';
          document.querySelector('.template-cart .cart-recommendations__bar .text.info').style.display = 'none';
          // document.querySelector('.product-recommendations__slider-nav').style.display = 'none';
          document.querySelector('.template-cart .product-recommendations__slider-nav').setAttribute('style', 'display: none !important');

          // Display the 'gratis' elements
          document.querySelectorAll('.cart-items .gratis').forEach((gratis) => {
              gratis.style.display = 'grid';

              if (window.innerWidth > 768) {
                  gratis.style.display = 'table-row';
              }
          });

            const btnAddProduct = document.querySelector('.btn-add-product');
            if(btnAddProduct && !btnAddProduct.hasAttribute('data-listener-attached')) {
              // Create and store the handler function only once
              if (!this.btnAddProductHandler) {
                this.btnAddProductHandler = (event) => {
                  // Prevent multiple simultaneous requests
                  if (this.btnAddProductProcessing) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                  }

                  event.preventDefault(); // Prevent default form action
                  event.stopPropagation(); // Stop event bubbling
                  event.stopImmediatePropagation(); // Stop all other listeners

                  // Set processing flag
                  this.btnAddProductProcessing = true;

                  // Disable button to prevent multiple clicks
                  const button = event.target.closest('.btn-add-product');
                  if (button) {
                    button.disabled = true;
                    button.style.pointerEvents = 'none';
                    button.style.opacity = '0.6';
                  }

                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      id: 50373036147014, // Variant ID
                      quantity: 1, // Quantity
                    }),
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      console.log('Product added to cart:', data);
                      window.location.href = '/cart'; // Redirect to cart page
                    })
                    .catch((error) => {
                      console.error('Error adding product:', error);
                      // Reset processing flag on error
                      this.btnAddProductProcessing = false;
                      // Re-enable button on error
                      if (button) {
                        button.disabled = false;
                        button.style.pointerEvents = 'auto';
                        button.style.opacity = '1';
                      }
                    });
                  
                  return false;
                };
              }
              
              // Add the event listener with capture phase to ensure it runs first
              btnAddProduct.addEventListener('click', this.btnAddProductHandler, true);
              btnAddProduct.setAttribute('data-listener-attached', 'true');
              this.btnAddProductListenerAttached = true;
            }
      }
      else {
          document.querySelector('.template-cart .product-recommendations .section-header').style.display = 'block';
          document.querySelector('.template-cart .product-recommendations .swiper-wrapper').style.display = 'flex';
          document.querySelector('.template-cart .cart-recommendations__bar .bar').style.display = 'block';
          document.querySelector('.template-cart .cart-recommendations__bar .text.info').style.display = 'block';
          document.querySelector('.template-cart .product-recommendations__slider-nav').style.display = 'flex';

          // Hide the 'gratis' elements
          document.querySelectorAll('.cart-items .gratis').forEach((gratis) => {
              gratis.style.display = 'none';
          });

          // Remove event listener when limit is not reached
          const btnAddProduct = document.querySelector('.btn-add-product');
          if(btnAddProduct && this.btnAddProductHandler) {
            btnAddProduct.removeEventListener('click', this.btnAddProductHandler, true);
            btnAddProduct.removeAttribute('data-listener-attached');
            this.btnAddProductListenerAttached = false;
            this.btnAddProductProcessing = false;
          }
      }

      // Update the difference in price
      diff = diff.toFixed(2);
      diff = diff.toString().replace('.', ',');
      if (document.querySelector('.js-diff')) {
          document.querySelector('.js-diff').innerText = diff;
      }

      // Update the width of the progress bar
      let width = (total / limit) * 100 - 5;

      // Remove existing styles if already added to avoid duplication
      let existingBeforeStyle = document.querySelector('style[data-bar-before]');
      let existingAfterStyle = document.querySelector('style[data-bar-after]');
      if (existingBeforeStyle) existingBeforeStyle.remove();
      if (existingAfterStyle) existingAfterStyle.remove();

      // Add new styles for the progress bar
      let styleBefore = document.createElement('style');
      styleBefore.setAttribute('data-bar-before', 'true');
      styleBefore.innerHTML = `
          .cart-recommendations__bar .bar:before {
              width: ${width}% !important;
          }
      `;
      let styleAfter = document.createElement('style');
      styleAfter.setAttribute('data-bar-after', 'true');
      styleAfter.innerHTML = `
          .cart-recommendations__bar .bar:after {
              left: ${width}% !important;
          }
      `;
      document.head.appendChild(styleBefore);
      document.head.appendChild(styleAfter);
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};